import React, { useState } from 'react'
import slugify from 'slugify'

import ContactItem from '~/components/core/contactItem'
import Wysiwyg from '~/components/core/Wysiwyg/Wysiwyg'

import ButtonArrow from '~/components/core/buttonArrow'

import transformLink from '~/utils/transformLink'

const Tabs = ({ data }) => {
  // local state
  const initTab = slugify(
    data.items[0].fields ? data.items[0].fields.title : data.items[0].title,
  )
  const [activePanel, setActivePanel] = useState(initTab)

  let cta = null

  if (data.cta !== null && data.cta !== undefined) {
    cta = data.cta.fields ? data.cta.fields : data.cta
  }

  const { url, contentTypeContentful } = transformLink(cta, true, false)

  return (
    <div className="tabs-slice slice-bg slice-bg--blue">
      <div className="row">
        <div className="col-12 lg-col-8 xl-col-6 lg-col-offset-1 xl-col-offset-2">
          {data.titleContent && (
            <h2 className="title-block text-white">{data.titleContent}</h2>
          )}
          <ul className="flex overflow-auto md:overflow-hidden md:flex-wrap mb-10 md:mb-10 tabs-slice__list">
            {data.items.map((item, i) => {
              const pill = item.fields ? item.fields : item
              return (
                <li
                  className={`pr-4 ${i !== data.items.length - 1 ? 'md:pr-6' : ''} md:mb-5`}
                  key={i}
                >
                  <button
                    className={`pill pill--ghost-white ${activePanel === slugify(pill.title) && 'is-active'}`}
                    onClick={() => setActivePanel(slugify(pill.title))}
                  >
                    {pill.title}
                  </button>
                </li>
              )
            })}
          </ul>

          <div className="tabs">
            {data.items.map((item, i) => {
              const panel = item.fields ? item.fields : item

              return (
                <TabsPanel
                  key={i}
                  activePanel={activePanel}
                  item={panel}
                  parentHasTitle={data.titleContent}
                />
              )
            })}
          </div>

          {cta !== null && (
            <div className="mt-6 md:mt-8">
              <ButtonArrow
                text={cta.label}
                link={url}
                contentType={contentTypeContentful}
                color="purple"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const TabsPanel = ({ activePanel, item, parentHasTitle = false }) => {
  const content = item.content

  let ctaItem = null

  if (item.cta !== null && item.cta !== undefined) {
    ctaItem = item.cta.fields ? item.cta.fields : item.cta
  }

  const subLink = transformLink(ctaItem, true, false)
  const urlItem = subLink.url
  const contentTypeContentfulItem = subLink.contentTypeContentful

  return (
    <div
      className={`tabs__panel ${activePanel === slugify(item.title) ? 'is-active' : ''}`}
    >
      {parentHasTitle ? (
        <h3 className="text-24 md:text-32 uppercase mb-7 md:mb-9">
          {item.title}
        </h3>
      ) : (
        <h2 className="text-24 md:text-32 uppercase mb-7 md:mb-9">
          {item.title}
        </h2>
      )}

      <span className="title-block block">{item.subtitle1}</span>

      <Wysiwyg
        document={content}
        classes={!item.subtitle2 && !item.contactItems ? 'mb-7 md:mb-8' : ''}
      />

      {item.subtitle2 && (
        <span className="title-block mt-8 block">{item.subtitle2}</span>
      )}

      {item.contactItems && (
        <div className="flex flex-wrap">
          {item.contactItems.map((item, i) => {
            return (
              <div className="md:w-1/2 mb-7 md:mb-8 md:pr-8" key={i}>
                <ContactItem type="tab" data={item} />
              </div>
            )
          })}
        </div>
      )}

      {ctaItem !== null && (
        <div className="mt-6 md:mt-8 mb-7 md:mb-8">
          <ButtonArrow
            text={ctaItem.label}
            link={urlItem}
            contentType={contentTypeContentfulItem}
            color="purple"
          />
        </div>
      )}
    </div>
  )
}

export default Tabs
